module.exports = __webpack_public_path__ + "img/outilvert_off.1a519a60.gif";